import { createContext } from 'react';
import { AuthError, Provider, Session, User } from '@supabase/supabase-js';
import { IUser } from '@Clients/UserClient';

export interface AuthContextProps {
  supabaseUser: null | User;
  baseUser: IUser | null;
  session:
    | Session
    | null
    | {
        data: {
          session: Session;
        };
        error: null;
      }
    | {
        data: {
          session: null;
        };
        error: AuthError;
      }
    | {
        data: {
          session: null;
        };
        error: null;
      };
  isAuthenticated: boolean;
  signIn: () => Promise<SignInResponse | UnknownSignInResponse | null>;
  signOut: () => Promise<void>;

  setBaseUser: (baseUser: IUser) => void;
}

interface SignInResponse {
  data: {
    provider: Provider;
    url: string;
  };
  error: null;
}

interface UnknownSignInResponse {
  data: null;
  error: unknown;
}

export const AuthContext = createContext<AuthContextProps>({
  supabaseUser: null,
  baseUser: null,
  signIn: async () => {
    return null;
  },
  signOut: async () => {},
  session: null,
  isAuthenticated: false,

  setBaseUser: () => {},
});
